// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__dvTWa","avatar":"style_avatar__2tS17"};